export default __webpack_public_path__ + "static/media/icon_notification_dashboard.529581d4.svg";